import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'AddInactiveUserToCallwebForm',

  components: {
    ShUserAvatar,
    ShButton,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedProfile: 1,
    };
  },

  computed: {
    userProfilesList() {
      return this.$store.getters['userProfiles/list'];
    },
  },

  methods: {
    handleCancel() {
      this.selectedProfile = 1;
      this.$emit('closeModal');
    },
    async addUserToCallweb() {
      await this.$store.dispatch('users/add', {
        users_uuid: this.user.users_uuid,
        users_permissions_profiles_id_fk: this.selectedProfile,
      });
      await this.$store.dispatch('users/getList');
      this.$emit('closeModal');
      this.$notify.success({
        title: 'Nowy użytkownik',
        message: 'Aktywowano nowego użytkownika na platfromie callweb',
        customClass: 'callmeweb-notification',
      });
    },
  },
};
